import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, finalize, skip, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'geo-filter',
  templateUrl: 'filter.component.html',
  styleUrls: ['./filter.component.less']
})
export class FilterComponent {
  @ViewChild('input') input: FormControl;

  @Input() query: string;

  @Output() filter = new EventEmitter<string>();
  @Output() close = new EventEmitter();

  showFilter = false;

  private hidden = new Subject();

  clear() {
    this.input.reset();
  }

  show() {
    this.showFilter = true;
    setTimeout(() => {
      this.input.valueChanges
        .pipe(
          skip(1),
          takeUntil(this.hidden),
          finalize(() => {
            this.filter.emit(null);
          }),
          debounceTime(300),
          distinctUntilChanged()
        )
        .subscribe((value: string) => {
          this.filter.emit(value);
        });
    });
  }

  hide() {
    this.clear();
    this.hidden.next();
    this.hidden.unsubscribe();
    this.showFilter = false;
  }
}
